export default Object.assign(
  JSON.parse(
    JSON.stringify(require("models/block/blocks/command/blueprints/move.json")),
  ), //make sure all the values are deeply cloned
  {
    groups: ["year 1", "year 2"],
    args: {
      arguments: [
        {
          code: {
            type: "vector",
            x: -1,
            y: 0,
            "hard-lock": true,
            editable: true,
          },
        },
      ],
    },
  },
);
